import Section from "../Section"
import styles from "./ReferenceSlider.module.scss"
import { Swiper, SwiperSlide } from "swiper/react"
import { Autoplay, Keyboard, Navigation } from "swiper"
import "swiper/css"
import "swiper/css/pagination"
import ReferenceSliderSlide from "./Slide"
import { ChevronLeft, ChevronRight } from "react-feather"
import { useState } from "react"
import Image from "../Image"
import cx from "classnames"

const ReferenceSlider = ({ data }) => {
  // console.log("ReferenceSlider", data)

  const [swiper, setSwiper] = useState(null)
  const [activeSlideIndex, setActiveSlideIndex] = useState(0)

  const images = data?.reference_items?.map((r) => r.image)

  function getSwiperActiveIndex(swipe) {
    let activeIndex = swipe.activeIndex
    let slidesLen = swipe.slides.length
    if (swipe.params.loop) {
      switch (swipe.activeIndex) {
        case 0:
          activeIndex = slidesLen - 3
          break
        case slidesLen - 1:
          activeIndex = 0
          break
        default:
          --activeIndex
      }
    }
    return activeIndex
  }

  return (
    <Section
      teaser={data?.section_teaser}
      headline={data?.section_headline}
      subline={data?.section_subline}
      text={data?.section_text}
      links={data?.section_links}
    >
      <div className={styles.ReferenceSlider}>
        <div className={styles.contentWrapper}>
          <div className="container">
            <Swiper
              onSwiper={(swipe) => {
                setSwiper(swipe)
              }}
              loop={true}
              keyboard={{
                enabled: true,
                pageUpDown: false,
              }}
              navigation={{
                nextEl: ".reference-slider-swiper-button-next",
                prevEl: ".reference-slider-swiper-button-prev",
              }}
              modules={[Navigation, Keyboard, Autoplay]}
              autoplay={
                data?.autoplay
                  ? {
                      delay: 5000,
                      disableOnInteraction: false,
                      pauseOnMouseEnter: true,
                      waitForTransition: true,
                    }
                  : false
              }
              slidesPerView={1}
              onSlideChange={(swipe) => {
                setActiveSlideIndex(getSwiperActiveIndex(swipe))
              }}
            >
              {data?.reference_items?.map((item, index) => (
                <SwiperSlide key={index}>
                  <ReferenceSliderSlide data={item} />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className={styles.swiperNav}>
            <span className="reference-slider-swiper-button-prev btn btn-primary !p-3 mr-4">
              <ChevronLeft />
            </span>
            <span className="reference-slider-swiper-button-next btn btn-primary !p-3">
              <ChevronRight />
            </span>
          </div>
        </div>

        <div className={styles.imageWrapper}>
          <div className={styles.imageInner}>
            <Image
              alt={images[activeSlideIndex].alt}
              src={images[activeSlideIndex].permalink}
              fill
              style={{
                objectFit: "cover",
                objectPosition: `${images[activeSlideIndex].focus_css}`,
              }}
            />
          </div>

          <div className={styles.swiperNav}>
            <span className="reference-slider-swiper-button-prev btn btn-primary !p-3 mr-4">
              <ChevronLeft />
            </span>
            <span className="reference-slider-swiper-button-next btn btn-primary !p-3">
              <ChevronRight />
            </span>
          </div>
        </div>
      </div>
      <div className={styles.navigationWrapper}>
        {data?.reference_items?.map((item, index) => (
          <div
            key={index}
            className={cx(styles.navigationItem, {
              [styles.active]: index === activeSlideIndex,
            })}
            onClick={() => {
              swiper && swiper.slideTo(index + 1)
            }}
          >
            {item?.navigation_name || ""}
          </div>
        ))}
      </div>
    </Section>
  )
}

export default ReferenceSlider
